import axios from 'axios';
export class BaseApiClient {
    constructor(config, serviceName) {
        this.config = config;
        this.client = axios.create({
            baseURL: config.baseURL,
            timeout: config.timeout || 30000,
            headers: {
                'Content-Type': 'application/json',
            },
        });
        this.client.interceptors.request.use(async (axiosConfig) => {
            if (this.config.authType === 'api-key' && this.config.apiKey) {
                axiosConfig.headers['x-api-key'] = this.config.apiKey;
            }
            else if (this.config.authType === 'jwt' && this.config.getJwtToken) {
                const token = await this.config.getJwtToken();
                axiosConfig.headers['Authorization'] = `Bearer ${token}`;
            }
            if (this.config.interceptors?.onRequest) {
                return await this.config.interceptors.onRequest(axiosConfig);
            }
            return axiosConfig;
        }, async (error) => {
            if (this.config.interceptors?.onRequestError) {
                return await this.config.interceptors.onRequestError(error);
            }
            return Promise.reject(error);
        });
        this.client.interceptors.response.use((response) => {
            if (this.config.interceptors?.onResponse) {
                return this.config.interceptors.onResponse(response);
            }
            return response;
        }, async (error) => {
            const errorMessage = error.response?.data?.message ||
                error.response?.data?.error ||
                error.message;
            const statusCode = error.response?.status;
            console.error(`[${serviceName}] API Error (${statusCode}):`, errorMessage, error.response?.data || '');
            if (this.config.interceptors?.onResponseError) {
                return await this.config.interceptors.onResponseError(error);
            }
            const enhancedError = new Error(errorMessage);
            enhancedError.status = statusCode;
            enhancedError.response = error.response?.data;
            throw enhancedError;
        });
        console.log(`[${serviceName}] Initialized API client with ${config.authType} auth`);
    }
    createRequestConfig(additionalHeaders) {
        return {
            headers: {
                ...additionalHeaders,
            },
        };
    }
    truncateError(error) {
        if (error instanceof Error) {
            const apiError = error;
            const message = apiError.response?.message ||
                apiError.response?.error ||
                apiError.message ||
                'Unknown error';
            return message.length > 100 ? message.substring(0, 97) + '...' : message;
        }
        return 'Unknown error';
    }
    async get(url, config) {
        const response = await this.client.get(url, this.createRequestConfig(config?.headers));
        return response.data;
    }
    async post(url, data, config) {
        const response = await this.client.post(url, data, this.createRequestConfig(config?.headers));
        return response.data;
    }
    async put(url, data, config) {
        const response = await this.client.put(url, data, this.createRequestConfig(config?.headers));
        return response.data;
    }
    async patch(url, data, config) {
        const response = await this.client.patch(url, data, this.createRequestConfig(config?.headers));
        return response.data;
    }
    async delete(url, config) {
        const response = await this.client.delete(url, { ...this.createRequestConfig(config?.headers), data: config?.data });
        return response.data;
    }
}
//# sourceMappingURL=base-api-client.js.map